module.exports = __webpack_public_path__ + "img/logo-mobile.8c5811d5.png";